module.exports = __webpack_public_path__ + "img/20200217201920360截图20200217201436674.3a20977e.jpg";